export const MODEL_CLASS = 'mobile-model';
